module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.protocol.visible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "title": "《美团收银服务协议》《隐私政策》更新通知"
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.protocol, "visible", $event)
      }
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "content"
  }, [_vm._v("尊敬的商家：")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n          感谢您信任并使用智能收银系统服务。依据最新法律要求，我们更新了《美团收银服务协议》及《隐私政策》，并根据您使用服务的具体功能对您的个人信息进行收集、使用和共享。\n          请您仔细阅读《美团收银服务协议》及《隐私政策》，并确认了解我们对您提供的服务以及对您个人信息处理原则。\n        ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "content"
  }, [_vm._v("如您同意\n          "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.openAgreementDialog
    }
  }, [_vm._v("《美团收银服务协议》")]), _vm._v("及\n          "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.openPrivacyDialog
    }
  }, [_vm._v("《隐私政策》")]), _vm._v("\n          ，请点击“同意”后使用我们的产品和服务，我们依法尽全力向您提供服务并保护您的个人信息。\n          ")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleDisagree
    }
  }, [_vm._v("不同意")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAgree
    }
  }, [_vm._v("同意")])], 1)]), _vm._v(" "), _c('agreement-dialog', {
    ref: "agreement"
  }), _vm._v(" "), _c('privacy-dialog', {
    ref: "privacy"
  }), _vm._v(" "), _c('warning-dialog', {
    attrs: {
      "warning": _vm.warning,
      "warningCount": _vm.warningCount
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fd77187"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/AgreementSign/Protocol.vue
// module id = 186
// module chunks = 0